// NotesApp source file : _components/admin.component.ts
import { Component, OnInit, Renderer2 } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { ActivatedRoute, RouterModule, Router } from '@angular/router';
import { Note, Project, Status, NoteType, DataService, Category } from '../../_service/data.service';
import { AuthService } from '../../_service/auth.service';
// import { ExportPDFComponent } from '../export-pdf/export-pdf.component';
import { UserSettingsService } from '../../_service/user-settings.service';
import { FormsModule } from '@angular/forms';
//import { PdfService } from '../../_service/pdf.service';
import { EditCategoriesComponent } from '../edit-categories/edit-categories.component';
import { SliderModule } from 'primeng/slider';
import { SelectModule } from 'primeng/select';
import { Observable } from 'rxjs';

interface Country {
    name: string;
    code: string;
}

@Component({
    selector: 'admin',
    //imports: [MatSliderModule, FormsModule, CommonModule, CategoryTreeComponent, CategoryTree2Component],
    imports: [FormsModule, CommonModule, SliderModule, SelectModule],
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.scss']
})

export class AdminComponent implements OnInit {
    clientType: any;
    platform: string = '';
    availableThemes: string[] = [];
    selectedTheme: string = '';
    menuItems = Array.from({ length: 1000 }, (_, i) => ({ id: i, name: `Item ${i + 1}` }));
    all_categories: Category[] = [];
    categoryItems: { ID: string; ItemName: string; isSelected?: Boolean; }[] = []; // List of items to select from
    selectedCategoryIDs: string[] = [];
    selectedCategory: Category | null = null;
    countries: Country[] = [];
    selectedCountry?: Country;
    constructor(
        private auth: AuthService,
        private data_service: DataService,
        private route: ActivatedRoute,
        private router: Router,
        private userSettingsService: UserSettingsService,
        private renderer: Renderer2,
        //private pdfService: PdfService
    ) {
      
    }


    ngOnInit(): void {
        //this.getCategories();
        this.userSettingsService.loadSavedTheme();
        this.selectedTheme = localStorage.getItem('selectedTheme') || this.availableThemes[0];
        this.countries = [
            {
                name: "India",
                code: "+91"
            },
            {
                name: "Nepal",
                code: "+977"
            },
            {
                name: "Bhutan",
                code: "+975"
            },
            {
                name: "Russia",
                code: "+7"
            },
            {
                name: "Bangladesh",
                code: "+880"
            },
            {
                name: "Canada",
                code: "+1"
            }
        ];
    }


    // exportPDF(): void {
    //     this.router.navigate(['/export-pdf']);
    // }
    tailwindTest(): void {
        this.router.navigate(['/home']);
    }

    onThemeChange(event: any) {
        const selectedTheme = event.target.value;
        this.userSettingsService.applyTheme(selectedTheme);
    }
    home(): void {
        this.router.navigate(['/home']);
    }


    /** Navigate to Edit Categories Page and Pass Categories */
    goToEditCategories() {
        this.router.navigate(['/edit-categories'], { state: { categories: this.all_categories } });
    }

    goToEditTags() {
        this.router.navigate(['/edit-tags']);
    }

    goToManageAttachments() {
        this.router.navigate(['/manage-attachments']);
    }


    downloadNotesDB(): void {
        this.data_service.getAllNotes().subscribe(
            (data) => {
                const jsonStr = JSON.stringify(data, null, 2);
                const blob = new Blob([jsonStr], { type: 'application/json' });
                const url = window.URL.createObjectURL(blob);
                const now = new Date();
                const timestamp = now.getFullYear().toString() +
                  (now.getMonth() + 1).toString().padStart(2, '0') +
                  now.getDate().toString().padStart(2, '0') + '-' +
                  now.getHours().toString().padStart(2, '0') +
                  now.getMinutes().toString().padStart(2, '0') +
                  now.getSeconds().toString().padStart(2, '0');

                const a = document.createElement('a');
                a.href = url;
                a.download = `NotesAppData_Backup_${timestamp}.json`;
                document.body.appendChild(a); // Append to body
                a.click();
                document.body.removeChild(a); // Remove from body

                window.URL.revokeObjectURL(url);
            },
            (error) => {
                console.error('Error downloading the notes:', error);
            }
        );
    }

}
